import React from 'react';
import { Control, Fieldset } from 'react-redux-form';
import MaskedInput from 'react-text-mask';
import { enumCitizenship, PLACEHOLDER_OPT } from './Schemas/baseRrf';
import Select from './Controls/Select';
import InputField from './Controls/Field';
import BirthdayField from './Controls/BirthdayField';
import {
  validateDate,
  validateDOBisOverEighteen,
  validateTaxIdNum,
  validateTaxIdNumLen,
  validateName,
} from './Validators';

const fields = [
  {
    model: '.firstName',
    RRFComp: Control.text,
    control: {
      placeholder: 'First Name',
      maxLength: 20,
      errors: {
        required: val => !val || !val.length,
        name: val => val && !validateName(val),
      },
    },
    error: {
      messages: {
        required: 'Please provide your First Name.',
        name: 'First Name may only include letters, spaces, dashes, and periods.',
      },
    },
  },
  {
    model: '.middleInitial',
    RRFComp: Control.text,
    control: {
      maxLength: 1,
      placeholder: 'Middle Initial (Optional)',
      errors: {
        name: val => val && !/^[a-zA-Z]$/.test(val),
      },
    },
    error: {
      messages: {
        name: 'Middle Initial must be a letter.',
      },
    },
  },
  {
    model: '.lastName',
    RRFComp: Control.text,
    control: {
      maxLength: 35,
      placeholder: 'Last Name',
      errors: {
        required: val => !val || !val.length,
        name: val => val && !validateName(val),
      },
    },
    error: {
      messages: {
        required: 'Please provide your Last Name.',
        name: 'Last Name may only include letters, spaces, dashes, and periods.',
      },
    },
  },
  {
    model: '.dateOfBirth',
    RRFComp: Control,
    control: {
      component: BirthdayField,
      errors: {
        required: val => !val || !val.length,
        isDate: val => val && !validateDate(val),
        isOverEighteen: val => val && validateDate(val) && !validateDOBisOverEighteen(val),
      },
    },
    error: {
      messages: {
        required: 'Please provide your Birth Date.',
        isDate: val => `${val} is not a valid Birth Date.`,
        isOverEighteen: 'You must be over 18 to register.',
      },
    },
  },
  {
    model: '.taxIdNum',
    RRFComp: Control,
    control: {
      component: MaskedInput,
      parser: val => (val && val.replace(/-/g, '')),
      mask: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
      guide: false,
      placeholder: 'Social Security #',
      maxLength: 11,
      style: {
        width: '100%',
        border: 'none',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: '#706e6e',
      },
      errors: {
        required: val => !val || !val.length,
        isTaxIdNum: val => val && (!validateTaxIdNumLen(val) || !validateTaxIdNum(val)),
      },
    },
    error: {
      messages: {
        required: 'Please provide your Social Security #.',
        isTaxIdNum: val => `${val} is not a valid Social Security #.`,
      },
    },
  },
  {
    model: '.citizenship',
    RRFComp: Control,
    control: {
      component: Select,
      errors: {
        required: val => !val || !val.length || val === PLACEHOLDER_OPT,
      },
    },
    error: {
      messages: {
        required: 'Please select your Citizenship status.',
      },
    },
  },
  {
    model: '.residenceCountry',
    RRFComp: Control.text,
    control: {
      type: 'hidden',
    },
  },
];

const Identity = ({ identityPath }) => (
  <Fieldset model={identityPath}>
    {fields.map((field, idx) => (idx < 5 ?
      <InputField key={field.model} fieldProps={field} /> : null))}
    <InputField key={fields[5].model} fieldProps={fields[5]}>
      {Object.keys(enumCitizenship).map(key => (
          (key === PLACEHOLDER_OPT) ?
            <option key={key} disabled value={key}>{enumCitizenship[key]}</option>
          : <option key={key} value={key}>{enumCitizenship[key]}</option>
        ))}
    </InputField>
  </Fieldset>
);

export default Identity;




// WEBPACK FOOTER //
// ./src/components/Forms/Identity.js